import { requestApi } from './Api';

export const getVideosList = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/list',
    params
  });

export const initiateVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/initiate',
    params
  });

export const presignVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/presign',
    params
  });

export const completeVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/complete',
    params
  });

export const deleteVideo = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/delete',
    params
  });

export const getVideo = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/video/get',
    params
  });

export const getVideoProgress = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/video_progress/get',
    params
  });

export const updateVideoProgress = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/video_progress/update',
    params
  });

export const completeVideoProgress = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/video_progress/complete',
    params
  });

export const activateVideo = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/activate',
    params
  });
